import styles from 'components/Chart/Chart/Tooltip.module.scss'

export const getOrCreateTooltip = (chart) => {
  let tooltipEl = document.getElementById('chart-tooltip')

  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.classList.add(styles.tooltip)
    tooltipEl.id = 'chart-tooltip'
    const table = document.createElement('table')
    table.className = styles['tooltip__table']
    tooltipEl.appendChild(table)
    const closeButton = document.createElement('div')
    closeButton.className = styles['tooltip__close-button']
    tooltipEl.addEventListener('click', function () {
      tooltipEl.style.display = 'none'
    })
    tooltipEl.appendChild(closeButton)
    chart.canvas.parentNode.parentNode.parentNode.appendChild(tooltipEl)
  }
  tooltipEl.style.display = 'block'
  return tooltipEl
}
